import {
  CorporateFormFields,
  ReportingOption,
  CorpInvoicingMethod,
  CorpInvoicingPeriod,
} from 'src/components/enterprise/features/Corporate/components/Form/types/CorporateForm';
import { BrandOptionsEnum } from 'src/components/enterprise/features/Corporate/components/Form/BrandOptions/BrandOptions';
import {
  CorpSubscriptionFundingType,
  SSOIdentifierEnum,
  InvoicingSubtotalMethod,
} from 'src/types/Corp';

export const ghPlusSubscriptionDefaultValues = {
  trialLengthDays: '',
  monthlyFeeField: null,
  funding: CorpSubscriptionFundingType.EMPLOYEE,
  monthlyFeeSelect: '',
};

export const sftpDefaultValues = {
  fileEncryptionEnabled: false,
  sftpOptions: {
    sftpEmployeesEnabled: false,
    sftpExpenseCodesEnabled: false,
  },
  sftpNotificationEmails: [],
};

export const corporateFormDefaultValues: CorporateFormFields = {
  name: '',
  clientId: '',
  phoneNumber: '',
  invoiceTimeZone: '',
  markets: '',
  salesPersonCode: null,
  expenseCodeAliasSingular: '',
  intacctTermName: '',
  intacctStatus: '',
  firmTransactionFee: '0',
  brand: BrandOptionsEnum.GRUBHUB,
  effectiveDate: null,
  automatedEmailsEnabled: false,
  autoInvoicingEnabled: true,
  allocationsPermitted: false,
  groupOrderEnabled: false,
  ghPlusEnabled: false,
  orderingPolicyEnabled: false,
  orderPolicyId: '',
  ghPlusSubscription: ghPlusSubscriptionDefaultValues,
  sftpNotificationEmailsString: '',
  enableSFTP: false,
  universalAccountsEnabled: true,
  piiProtectedMarketing: false,
  taxExemptEnabled: false,
  disableMealCreditGracePeriod: false,
  maxCreditCardCharge: 0,
  invoicePaymentMethod: '',
  ssoEnabled: false,
  ssoRedirectEnabled: false,
  ssoRedirectUrl: '',
  passwordRestricted: false,
  passwordRestrictedToggleLock: false,
  ssoIdentifier: SSOIdentifierEnum.EMAIL,
  reporting: ReportingOption.NONE_REPORTING_OPTION,
  invoiceContactFirstName: '',
  invoiceContactLastName: '',
  invoicingMethod: CorpInvoicingMethod.SINGLE_OPTION,
  invoicingSubtotalMethod:
    InvoicingSubtotalMethod.MEAL_TYPE_SUBTOTAL_INVOICE_METHOD,
  invoiceRrule: CorpInvoicingPeriod.WEEKLY,
  invoiceContactEmail: '',
  invoiceContactPhoneNumber: '',
  invoiceContactCity: '',
  invoiceContactAddress1: '',
  invoiceContactAddress2: '',
  invoiceContactZip: '',
  invoiceContactState: '',
  ...sftpDefaultValues,
  dinerLocationRequired: false,
  dinerDepartmentRequired: false,
  cateringServiceFee: '0',
  enableMerchantRestrictions: false,
  defaultMerchantRestrictions: {},
  enableItemRestrictions: false,
  defaultItemRestrictions: {},
  enableDinerNotificationPreferences: false,
  dinerNotificationPreferences: {},
};
